module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-indexDesc"
  }, [_c('topNav', {
    attrs: {
      "title": _vm.$t('indexDesc_title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tipBar"
  }, [_c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_total_revenue')
    }
  }, [_vm._v(_vm._s(_vm.$t('indexDesc_total_revenue_value'))), _c('br'), _vm._v(_vm._s(_vm.$t('indexDesc_total_revenue_value1')) + "\n    ")]), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_available'),
      "value": _vm.$t('indexDesc_available_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_take_up_room'),
      "value": _vm.$t('indexDesc_take_up_room_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_overnight_rate'),
      "value": _vm.$t('indexDesc_overnight_rate_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_night_average'),
      "value": _vm.$t('indexDesc_night_average_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": "REVPAR",
      "value": _vm.$t('indexDesc_REVPAR_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_total_rooms'),
      "value": _vm.$t('indexDesc_total_rooms_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_since_room'),
      "value": _vm.$t('indexDesc_since_room_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_free_room'),
      "value": _vm.$t('indexDesc_free_room_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_maintenance_room'),
      "value": _vm.$t('indexDesc_maintenance_room_value')
    }
  }), _vm._v(" "), _c('mt-cell', {
    attrs: {
      "title": _vm.$t('indexDesc_locked_room'),
      "value": _vm.$t('indexDesc_locked_room_value')
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-605301de","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/indexDesc.vue
// module id = 1794
// module chunks = 107